import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15b57798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-pdf-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = { class: "configs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导出范围：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("全部幻灯片")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("当前幻灯片")
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "每页数量：", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("2")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("3")
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "边缘留白：", -1))
const _hoisted_15 = { class: "config-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 注意：若打印预览与实际样式不一致，请在弹出的打印窗口中勾选【背景图形】选项。 ", -1))
const _hoisted_17 = { class: "btns" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("打印 / 导出 PDF")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("关闭")

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { print } from '@/utils/print'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportPDF',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const { slides, currentSlide } = storeToRefs(useSlidesStore())

const pdfThumbnailsRef = ref<HTMLElement>()
const rangeType = ref<'all' | 'current'>('all')
const count = ref(1)
const padding = ref(true)

const expPDF = () => {
  if (!pdfThumbnailsRef.value) return
  const pageSize = {
    width: 1600,
    height: rangeType.value === 'all' ? 900 * count.value : 900,
    margin: padding.value ? 50 : 0,
  }
  print(pdfThumbnailsRef.value, pageSize)
}

return (_ctx: any,_cache: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "thumbnails",
        ref_key: "pdfThumbnailsRef",
        ref: pdfThumbnailsRef
      }, [
        (rangeType.value === 'current')
          ? (_openBlock(), _createBlock(ThumbnailSlide, {
              key: 0,
              class: "thumbnail",
              slide: _unref(currentSlide),
              size: 1600
            }, null, 8, ["slide"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(slides), (slide, index) => {
              return (_openBlock(), _createBlock(ThumbnailSlide, {
                class: _normalizeClass(["thumbnail", { 'break-page': (index + 1) % count.value === 0 }]),
                key: slide.id,
                slide: slide,
                size: 1600
              }, null, 8, ["class", "slide"]))
            }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: rangeType.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rangeType).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "all"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "current"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Select, {
          class: "config-item",
          value: count.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((count).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SelectOption, { value: 1 }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_SelectOption, { value: 2 }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_SelectOption, { value: 3 }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Switch, {
            checked: padding.value,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((padding).value = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (expPDF()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn close",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      })
    ])
  ]))
}
}

})